<div class="resource-container">
  <div
    class="resource-icon-container"
    [ngStyle]="{ 'border-color': resource.color }"
  >
    @if (!resource.isParent) {
      <img
        [ngStyle]="{ 'border-color': resource.color }"
        loading="lazy"
        [id]="'img' + resource.id"
        class="resource-img"
        [alt]="resource.name"
        [src]="'https://assets.tridimo.de/img/p/' + resource.img"
        (error)="onImageError(resource)"
      />
    }
  </div>

  <div class="resource-name-title-container">
    <div class="resource-name-row">
      <div class="resource-name">
        {{ resource.name }}
      </div>

      @if (resource.isParent) {
        <div class="team-actions">
          @if (isExporting) {
            <div class="spinner"></div>
          }
          <mbsc-button size="small" variant="flat" (click)="doUnkenntlich()">
            <div
              class="info-icon"
              [innerHTML]="this.svgIconService.svgCache['camera']"
            ></div>
          </mbsc-button>
          @if (!isExporting) {
            <mbsc-button
              size="small"
              variant="flat"
              (click)="doScreenshot(resource)"
            >
              <div
                class="info-icon"
                [innerHTML]="this.svgIconService.svgCache['screenshot']"
              ></div>
            </mbsc-button>
          }
          @if (!resource.fixed) {
            <mbsc-button
              size="small"
              variant="flat"
              (click)="fixResource(resource)"
            >
              <div
                class="info-icon"
                [innerHTML]="this.svgIconService.svgCache['unfixed']"
              ></div>
            </mbsc-button>
          }
          @if (resource.fixed) {
            <mbsc-button
              size="small"
              variant="flat"
              (click)="unfixResource(resource)"
            >
              <div
                class="info-icon"
                [innerHTML]="this.svgIconService.svgCache['fixed']"
              ></div>
            </mbsc-button>
          }
        </div>
      }
    </div>

    <div class="resource-title">
      {{ resource.workingType }}
    </div>

    @if (resource.TOTAL_minutes != null && !isExporting) {
      <div
        class="event-minutes-container"
        [class.content-hidden]="minutesHidden"
      >
        <div class="holiday" title="Urlaub-Stunden">
          <div
            class="info-icon"
            [innerHTML]="this.svgIconService.svgCache['urlaub']"
          ></div>
          <div class="event-hours">
            {{ toRoundedHours(resource.HOLIDAYEVENT_minutes) }}
          </div>
        </div>
        <div class="meeting" title="Meeting-Stunden">
          <div
            class="info-icon"
            [innerHTML]="this.svgIconService.svgCache['besprechung']"
          ></div>
          <div class="event-hours">
            {{ toRoundedHours(resource.MEETINGEVENT_minutes) }}
          </div>
        </div>
        <div class="mission" title="Einsatz-Stunden">
          <div
            class="info-icon"
            [innerHTML]="this.svgIconService.svgCache['einsatz']"
          ></div>
          <div class="event-hours">
            {{ toRoundedHours(resource.MISSIONEVENT_minutes) }}
          </div>
        </div>
        <div class="sick" title="Krank-Stunden">
          <div
            class="info-icon"
            [innerHTML]="this.svgIconService.svgCache['krank']"
          ></div>
          <div class="event-hours">
            {{ toRoundedHours(resource.SICKEVENT_minutes) }}
          </div>
        </div>
      </div>
    }

    @if (resource.TOTAL_minutes && !isExporting) {
      <div
        class="total-container"
        title="Tag Stunden / Wochen Stunden / Überstunden (%)"
        [class.content-hidden]="minutesHidden"
      >
        Tag: {{ toRoundedHours(resource.TOTAL_minutes_day) }} | Woche:
        {{ toRoundedHours(resource.TOTAL_minutes) }} ({{
          resource.ueberstunden
        }}%)
      </div>
    }

    @if (
      !isExporting &&
      permissionService.userPermission === "admin" &&
      !resource.isParent
    ) {
      <div
        class="drive-time-container"
        title="Reale Fahrtzeiten und Buchhalterische Fahrtzeiten"
        [class.content-hidden]="minutesHidden"
      >
        <div
          class="info-icon"
          [innerHTML]="this.svgIconService.svgCache['car']"
        ></div>
        <span>
          || Real: {{ resource.traveltimeReal }} Std. | Abre.:
          {{ resource.traveltimeAccounting }} Std.</span
        >
      </div>
    }
  </div>
</div>
